var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VpKebabMenu',{attrs:{"size":"16px","menu-options":_vm._options,"menu-position":"down-left","open-by":"click"},on:{"click":_vm.activate}})
}
var staticRenderFns = []

export { render, staticRenderFns }